// button component for the pagination
import React from 'react'

const Button = ({ children, ...props }) => {
    return (
        <button
            className={`inline-block py-3 px-4 mx-px text-center leading-none rounded hover:bg-gray-100 focus:bg-gray-100 ${typeof children === "number" ? "w-12 px-1" : "px-4"}`} {...props}>{children}</button>
    );
}

export default Button
